(function() {
  if (window.BsignFadingMediaHero && typeof window.BsignFadingMediaHero.initAll === 'function') {
    window.BsignFadingMediaHero.initAll();
    return;
  }

  var sectionSelector = '[data-fading-media-hero]';
  var videoSelector = 'video[data-fading-media-video]';
  var itemSelector = '.fading-images__item';
  var imageSelector = '[data-fading-media-image] img';
  var dotSelector = '[data-fading-media-dot]';
  var hasPointerEvents = 'PointerEvent' in window;

  var classes = {
    activeImage: 'active-image',
    finishedImage: 'finished-image',
    activeTitles: 'active-titles',
    finishedTitles: 'finished-titles',
    compensation: 'compensation',
    swipeable: 'fading-media-hero--swipeable',
    dragging: 'is-dragging',
    initialReady: 'fading-media-hero--initial-ready',
    activeDot: 'is-active'
  };

  var textAlignmentClasses = [
    'vertical-center',
    'vertical-bottom',
    'horizontal-left',
    'horizontal-center',
    'horizontal-right'
  ];
  var buttonAlignments = ['left', 'center', 'right'];
  var instances = [];

  function toArray(items) {
    return Array.prototype.slice.call(items);
  }

  function getHorizontalAlignment(textAlign) {
    if (textAlign && textAlign.indexOf('horizontal-left') !== -1) {
      return 'left';
    }

    if (textAlign && textAlign.indexOf('horizontal-right') !== -1) {
      return 'right';
    }

    return 'center';
  }

  function sanitizeTextAlign(value, fallback) {
    var fallbackValue = fallback || 'vertical-center horizontal-center';
    var selectedValue = value && value !== 'inherit' ? value : fallbackValue;
    var vertical = '';
    var horizontal = '';

    selectedValue.split(/\s+/).forEach(function(className) {
      if (className === 'vertical-center' || className === 'vertical-bottom') {
        vertical = className;
      }

      if (
        className === 'horizontal-left' ||
        className === 'horizontal-center' ||
        className === 'horizontal-right'
      ) {
        horizontal = className;
      }
    });

    if (!vertical) {
      vertical = fallbackValue.indexOf('vertical-bottom') !== -1 ? 'vertical-bottom' : 'vertical-center';
    }

    if (!horizontal) {
      horizontal = 'horizontal-' + getHorizontalAlignment(fallbackValue);
    }

    return vertical + ' ' + horizontal;
  }

  function sanitizeButtonAlign(value, textAlign) {
    if (buttonAlignments.indexOf(value) !== -1) {
      return value;
    }

    return getHorizontalAlignment(textAlign);
  }

  function normalizePercent(value, fallback) {
    var parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      return fallback;
    }

    return Math.max(0, Math.min(100, parsedValue));
  }

  function getPercentAttribute(element, attribute, fallback) {
    if (!element) {
      return fallback;
    }

    return normalizePercent(element.getAttribute(attribute), fallback);
  }

  function setPercentVariable(element, property, value) {
    if (element) {
      element.style.setProperty(property, value + '%');
    }
  }

  function loadVideo(video) {
    if (!video || video.dataset.fadingMediaLoaded === 'true') {
      return;
    }

    var poster = video.getAttribute('data-poster');
    var src = video.getAttribute('data-video-src');

    if (poster && !video.getAttribute('poster')) {
      video.setAttribute('poster', poster);
    }

    if (src && !video.getAttribute('src')) {
      video.setAttribute('src', src);
    }

    video.dataset.fadingMediaLoaded = 'true';
    video.classList.add('lazyloaded');

    if (src && typeof video.load === 'function') {
      video.load();
    }
  }

  function markImageItemLoaded(image) {
    var item = image && image.closest ? image.closest('[data-fading-media-image]') : null;

    if (!item) {
      return;
    }

    item.classList.remove('lazyload');
    item.classList.add('lazyloaded');
  }

  function bindImageLoadStates(section) {
    toArray(section.querySelectorAll(imageSelector)).forEach(function(image) {
      if (image.classList.contains('lazyloaded') || (image.complete && image.naturalWidth > 0)) {
        markImageItemLoaded(image);
        return;
      }

      image.addEventListener('load', function() {
        markImageItemLoaded(image);
      });

      image.addEventListener('lazyloaded', function() {
        markImageItemLoaded(image);
      });
    });
  }

  function playVideo(video, section) {
    if (!video) {
      return;
    }

    loadVideo(video);

    if (typeof video.play !== 'function') {
      return;
    }

    var playPromise = video.play();

    if (playPromise !== undefined && typeof playPromise.catch === 'function') {
      playPromise.catch(function() {
        video.setAttribute('controls', '');
        if (section) {
          section.classList.add('video-interactable');
        }
      });
    }
  }

  function pauseVideo(video) {
    if (video && typeof video.pause === 'function') {
      video.pause();
    }
  }

  function restartVideo(video) {
    if (!video) {
      return;
    }

    try {
      video.currentTime = 0;
    } catch (error) {
      // The video will still start at 0 when it is loaded for the first time.
    }
  }

  function FadingMediaHero(section) {
    this.section = section;
    this.hero = section.querySelector('.fading-media-hero');
    this.items = toArray(section.querySelectorAll(itemSelector));
    this.videos = toArray(section.querySelectorAll(videoSelector));
    this.dots = toArray(section.querySelectorAll(dotSelector));
    this.allTitles = toArray(section.querySelectorAll('.fading-images-overlay__titles'));
    this.textContent = section.querySelector('[data-fading-media-text-content]');
    this.defaultTextAlign = sanitizeTextAlign(
      this.textContent && this.textContent.getAttribute('data-default-text-align'),
      'vertical-center horizontal-center'
    );
    var defaultDesktopX = getPercentAttribute(this.hero, 'data-default-content-position-x', 50);
    var defaultDesktopY = getPercentAttribute(this.hero, 'data-default-content-position-y', 58);

    this.defaultContentPosition = {
      desktopX: defaultDesktopX,
      desktopY: defaultDesktopY,
      mobileX: getPercentAttribute(this.hero, 'data-default-mobile-content-position-x', defaultDesktopX),
      mobileY: getPercentAttribute(this.hero, 'data-default-mobile-content-position-y', defaultDesktopY)
    };
    this.slideCount = parseInt(section.getAttribute('data-count'), 10) || this.items.length;
    this.slideCount = Math.min(this.slideCount, this.items.length);
    this.finishInterval = 1000;
    this.autoplayInterval = 10000;
    this.activeSlide = 1;
    this.started = false;
    this.inView = false;
    this.titlesShown = false;
    this.timeouts = [];
    this.autoplayTimer = null;
    this.viewportObserver = null;
    this.pointerStart = null;
    this.swipeClickSuppressed = false;
    this.swipeClickTimer = null;
    this.swipeThreshold = 50;
    this.swipeAxisRatio = 1.2;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onPointerCancel = this.onPointerCancel.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onTouchCancel = this.onTouchCancel.bind(this);
    this.onClickCapture = this.onClickCapture.bind(this);
    this.onDotClick = this.onDotClick.bind(this);
    this.onVideoEnded = this.onVideoEnded.bind(this);

    this.init();
  }

  FadingMediaHero.prototype = {
    init: function() {
      if (!this.hero || !this.items.length) {
        return;
      }

      bindImageLoadStates(this.section);
      this.bindSwipe();
      this.bindDots();
      this.bindVideoEvents();
      this.updateDots(this.activeSlide);

      if ('IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            this.inView = entry.isIntersecting;

            if (this.inView) {
              this.resume();
            } else {
              this.pause();
            }
          }.bind(this));
        }.bind(this), {
          rootMargin: '0px',
          threshold: 0
        });

        this.viewportObserver.observe(this.section);
      } else {
        this.inView = true;
        this.resume();
      }
    },

    bindSwipe: function() {
      if (this.slideCount <= 1) {
        return;
      }

      this.hero.classList.add(classes.swipeable);

      if (hasPointerEvents) {
        this.hero.addEventListener('pointerdown', this.onPointerDown);
        this.hero.addEventListener('pointerup', this.onPointerUp);
        this.hero.addEventListener('pointercancel', this.onPointerCancel);
      } else {
        this.hero.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.hero.addEventListener('touchend', this.onTouchEnd);
        this.hero.addEventListener('touchcancel', this.onTouchCancel);
      }

      this.hero.addEventListener('click', this.onClickCapture, true);
    },

    unbindSwipe: function() {
      if (!this.hero || this.slideCount <= 1) {
        return;
      }

      this.hero.classList.remove(classes.swipeable, classes.dragging);

      if (hasPointerEvents) {
        this.hero.removeEventListener('pointerdown', this.onPointerDown);
        this.hero.removeEventListener('pointerup', this.onPointerUp);
        this.hero.removeEventListener('pointercancel', this.onPointerCancel);
      } else {
        this.hero.removeEventListener('touchstart', this.onTouchStart, { passive: true });
        this.hero.removeEventListener('touchend', this.onTouchEnd);
        this.hero.removeEventListener('touchcancel', this.onTouchCancel);
      }

      this.hero.removeEventListener('click', this.onClickCapture, true);
    },

    bindDots: function() {
      if (!this.dots.length || this.slideCount <= 1) {
        return;
      }

      this.dots.forEach(function(dot) {
        dot.addEventListener('click', this.onDotClick);
      }.bind(this));
    },

    unbindDots: function() {
      if (!this.dots.length) {
        return;
      }

      this.dots.forEach(function(dot) {
        dot.removeEventListener('click', this.onDotClick);
      }.bind(this));
    },

    bindVideoEvents: function() {
      this.videos.forEach(function(video) {
        video.addEventListener('ended', this.onVideoEnded);
      }.bind(this));
    },

    unbindVideoEvents: function() {
      this.videos.forEach(function(video) {
        video.removeEventListener('ended', this.onVideoEnded);
      }.bind(this));
    },

    onVideoEnded: function(event) {
      var video = event.currentTarget;
      var slideIndex = parseInt(video.getAttribute('data-slide-index'), 10);

      if (!this.inView || slideIndex !== this.activeSlide || !video.classList.contains(classes.activeImage)) {
        return;
      }

      this.goToSlide(this.activeSlide + 1, { autoplay: true, loop: true });
    },

    onDotClick: function(event) {
      event.preventDefault();

      var target = parseInt(event.currentTarget.getAttribute('data-slide-index'), 10);
      this.goToSlide(target, { manual: true, loop: true });
    },

    onPointerDown: function(event) {
      if (event.isPrimary === false || event.button > 0) {
        return;
      }

      this.pointerStart = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };

      this.hero.classList.add(classes.dragging);
    },

    onPointerUp: function(event) {
      if (!this.pointerStart || this.pointerStart.id !== event.pointerId) {
        return;
      }

      this.handleSwipe(event.clientX, event.clientY);
      this.pointerStart = null;
      this.hero.classList.remove(classes.dragging);
    },

    onPointerCancel: function() {
      this.pointerStart = null;
      this.hero.classList.remove(classes.dragging);
    },

    onTouchStart: function(event) {
      if (!event.touches || event.touches.length !== 1) {
        return;
      }

      this.pointerStart = {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };

      this.hero.classList.add(classes.dragging);
    },

    onTouchEnd: function(event) {
      if (!this.pointerStart || !event.changedTouches || !event.changedTouches.length) {
        return;
      }

      this.handleSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
      this.pointerStart = null;
      this.hero.classList.remove(classes.dragging);
    },

    onTouchCancel: function() {
      this.pointerStart = null;
      this.hero.classList.remove(classes.dragging);
    },

    handleSwipe: function(endX, endY) {
      var deltaX = endX - this.pointerStart.x;
      var deltaY = endY - this.pointerStart.y;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);

      if (absX < this.swipeThreshold || absX < absY * this.swipeAxisRatio) {
        return;
      }

      this.suppressNextClick();

      if (deltaX < 0) {
        this.goToSlide(this.activeSlide + 1, { manual: true, loop: true });
      } else {
        this.goToSlide(this.activeSlide - 1, { manual: true, loop: true });
      }
    },

    suppressNextClick: function() {
      this.swipeClickSuppressed = true;
      window.clearTimeout(this.swipeClickTimer);
      this.swipeClickTimer = window.setTimeout(function() {
        this.swipeClickSuppressed = false;
      }.bind(this), 450);
    },

    onClickCapture: function(event) {
      if (!this.swipeClickSuppressed) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      this.swipeClickSuppressed = false;
    },

    getSlide: function(index) {
      return this.section.querySelector('.fading-images__item[data-slide-index="' + index + '"]');
    },

    getTargetIndex: function(index, loop) {
      var target = parseInt(index, 10);

      if (!target || this.slideCount < 1) {
        return null;
      }

      if (target > this.slideCount) {
        return loop ? 1 : null;
      }

      if (target < 1) {
        return loop ? this.slideCount : null;
      }

      return target;
    },

    setLoaded: function() {
      this.hero.classList.remove('loading');
      this.hero.classList.add('loaded');
    },

    setTimeout: function(callback, delay) {
      var timer = window.setTimeout(function() {
        this.timeouts = this.timeouts.filter(function(savedTimer) {
          return savedTimer !== timer;
        });
        callback();
      }.bind(this), delay);

      this.timeouts.push(timer);
      return timer;
    },

    clearTimeouts: function() {
      this.timeouts.forEach(function(timer) {
        window.clearTimeout(timer);
      });
      this.timeouts = [];
    },

    clearAutoplay: function() {
      if (this.autoplayTimer) {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },

    scheduleAutoplay: function() {
      this.clearAutoplay();

      var activeSlide = this.getSlide(this.activeSlide);

      if (!this.inView || this.slideCount <= 1 || (activeSlide && activeSlide.matches(videoSelector))) {
        return;
      }

      this.autoplayTimer = window.setTimeout(function() {
        this.autoplayTimer = null;
        this.goToSlide(this.activeSlide + 1, { autoplay: true, loop: true });
      }.bind(this), this.autoplayInterval);
    },

    resume: function() {
      this.setLoaded();

      if (!this.started) {
        this.start();
        return;
      }

      if (!this.titlesShown) {
        this.updateTitle(this.activeSlide);
      }

      this.syncVideos();
      this.scheduleAutoplay();
    },

    pause: function() {
      this.clearTimeouts();
      this.clearAutoplay();
      this.syncVideos();
    },

    start: function() {
      var firstImage = this.getSlide(this.activeSlide);
      var hasPreparedMedia = firstImage && firstImage.classList.contains(classes.activeImage);
      var hasPreparedTitles = this.allTitles.some(function(title) {
        return title.classList.contains(classes.activeTitles);
      });

      this.started = true;

      if (hasPreparedMedia) {
        this.items.forEach(function(item) {
          if (item !== firstImage) {
            item.classList.remove(classes.activeImage, classes.finishedImage, classes.compensation);
          }
        });

        firstImage.classList.add(classes.activeImage, classes.compensation);
      } else {
        this.items.forEach(function(item) {
          item.classList.remove(classes.activeImage, classes.finishedImage, classes.compensation);
        });

        if (firstImage) {
          firstImage.classList.add(classes.activeImage);
          firstImage.classList.add(classes.compensation);
        }
      }

      if (hasPreparedTitles) {
        this.applyPreparedTitleState(firstImage);
      } else {
        this.updateTitle(this.activeSlide);
      }

      this.syncVideos();
      this.updateDots(this.activeSlide);
      this.scheduleAutoplay();
    },

    goToSlide: function(index, options) {
      var target = this.getTargetIndex(index, options && options.loop);

      if (!target || target === this.activeSlide) {
        if (this.inView && options && options.manual) {
          this.scheduleAutoplay();
        }
        return;
      }

      var previousSlide = this.getSlide(this.activeSlide);
      var nextSlide = this.getSlide(target);

      if (!nextSlide) {
        return;
      }

      this.hero.classList.remove(classes.initialReady);
      this.clearTimeouts();
      this.clearAutoplay();

      if (nextSlide.matches(videoSelector)) {
        restartVideo(nextSlide);
      }

      this.transitionMedia(previousSlide, nextSlide);
      this.activeSlide = target;
      this.updateTitle(this.activeSlide);
      this.updateDots(this.activeSlide);
      this.syncVideos();
      this.scheduleAutoplay();
    },

    transitionMedia: function(previousSlide, nextSlide) {
      this.items.forEach(function(item) {
        if (item !== previousSlide && item !== nextSlide) {
          item.classList.remove(classes.activeImage, classes.finishedImage, classes.compensation);
        }
      });

      if (previousSlide) {
        previousSlide.classList.remove(classes.activeImage, classes.compensation);
        previousSlide.classList.add(classes.finishedImage);

        this.setTimeout(function() {
          previousSlide.classList.remove(classes.finishedImage);
        }, this.finishInterval);
      }

      nextSlide.classList.remove(classes.finishedImage, classes.compensation, classes.activeImage);
      nextSlide.offsetWidth;
      nextSlide.classList.add(classes.activeImage);
    },

    setOptionalText: function(element, text) {
      if (!element) {
        return false;
      }

      if (text) {
        element.textContent = text;
        element.classList.remove('is-hidden');
        element.removeAttribute('aria-hidden');
        return true;
      }

      element.textContent = '';
      element.classList.add('is-hidden');
      element.setAttribute('aria-hidden', 'true');
      return false;
    },

    updateButton: function(button, label, link, opensCustomOrder) {
      if (!button) {
        return false;
      }

      var buttonLabel = label ? label.trim() : '';
      var isCustomOrderButton = opensCustomOrder === true || opensCustomOrder === 'true';

      if (!buttonLabel) {
        button.textContent = '';
        button.removeAttribute('href');
        button.removeAttribute('data-open-custom-order');
        button.removeAttribute('role');
        button.removeAttribute('tabindex');
        button.classList.add('is-hidden');
        button.setAttribute('aria-hidden', 'true');
        return false;
      }

      button.textContent = buttonLabel;
      button.classList.remove('is-hidden');
      button.removeAttribute('aria-hidden');

      if (isCustomOrderButton) {
        button.removeAttribute('href');
        button.setAttribute('data-open-custom-order', '');
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-haspopup', 'dialog');
      } else if (link) {
        button.removeAttribute('data-open-custom-order');
        button.removeAttribute('role');
        button.removeAttribute('tabindex');
        button.removeAttribute('aria-controls');
        button.removeAttribute('aria-expanded');
        button.removeAttribute('aria-haspopup');
        button.setAttribute('href', link);
      } else {
        button.removeAttribute('data-open-custom-order');
        button.removeAttribute('role');
        button.removeAttribute('tabindex');
        button.removeAttribute('aria-controls');
        button.removeAttribute('aria-expanded');
        button.removeAttribute('aria-haspopup');
        button.removeAttribute('href');
      }

      return true;
    },

    applyTextAlignment: function(slide) {
      var textAlign = sanitizeTextAlign(
        slide && slide.getAttribute('data-slide-text-align'),
        this.defaultTextAlign
      );

      if (this.textContent) {
        textAlignmentClasses.forEach(function(className) {
          this.textContent.classList.remove(className);
        }.bind(this));

        textAlign.split(/\s+/).forEach(function(className) {
          if (className) {
            this.textContent.classList.add(className);
          }
        }.bind(this));
      }

      return textAlign;
    },

    applyButtonAlignment: function(buttons, slide, textAlign) {
      if (!buttons) {
        return;
      }

      buttons.setAttribute(
        'data-fading-media-button-align',
        sanitizeButtonAlign(slide && slide.getAttribute('data-slide-button-align'), textAlign)
      );
    },

    applyContentPosition: function(slide) {
      var desktopX = getPercentAttribute(
        slide,
        'data-slide-content-position-x',
        this.defaultContentPosition.desktopX
      );
      var desktopY = getPercentAttribute(
        slide,
        'data-slide-content-position-y',
        this.defaultContentPosition.desktopY
      );
      var mobileX = getPercentAttribute(
        slide,
        'data-slide-mobile-content-position-x',
        this.defaultContentPosition.mobileX
      );
      var mobileY = getPercentAttribute(
        slide,
        'data-slide-mobile-content-position-y',
        this.defaultContentPosition.mobileY
      );

      setPercentVariable(this.hero, '--fading-media-content-x', desktopX);
      setPercentVariable(this.hero, '--fading-media-content-y', desktopY);
      setPercentVariable(this.hero, '--fading-media-content-translate-x', desktopX * -1);
      setPercentVariable(this.hero, '--fading-media-content-translate-y', desktopY * -1);
      setPercentVariable(this.hero, '--fading-media-content-mobile-x', mobileX);
      setPercentVariable(this.hero, '--fading-media-content-mobile-y', mobileY);
      setPercentVariable(this.hero, '--fading-media-content-mobile-translate-x', mobileX * -1);
      setPercentVariable(this.hero, '--fading-media-content-mobile-translate-y', mobileY * -1);
    },

    applyMobileTitleMaxWidth: function(slide) {
      setPercentVariable(
        this.hero,
        '--fading-media-mobile-title-max-width',
        getPercentAttribute(slide, 'data-slide-mobile-title-max-width', 50)
      );
    },

    applyPreparedTitleState: function(slide) {
      var buttons = this.section.querySelector('[data-fading-media-buttons]');
      this.applyContentPosition(slide);
      this.applyMobileTitleMaxWidth(slide);
      this.applyButtonAlignment(buttons, slide, this.applyTextAlignment(slide));
      this.titlesShown = true;
    },

    updateTitle: function(index) {
      var slide = this.getSlide(index);
      var titleOne = this.section.querySelector('.fading-images-overlay__title--1');
      var titleTwo = this.section.querySelector('.fading-images-overlay__title--2');
      var titleMobile = this.section.querySelector('[data-fading-media-mobile-title]');
      var subtitle = this.section.querySelector('[data-fading-media-subtitle]');
      var buttons = this.section.querySelector('[data-fading-media-buttons]');
      var buttonOne = this.section.querySelector('[data-fading-media-button="1"]');
      var buttonTwo = this.section.querySelector('[data-fading-media-button="2"]');
      this.applyContentPosition(slide);
      this.applyMobileTitleMaxWidth(slide);
      var textAlign = this.applyTextAlignment(slide);

      this.applyButtonAlignment(buttons, slide, textAlign);

      if (slide && titleOne) {
        var titleOneText = slide.getAttribute('data-slide-title1') || '';
        var titleTwoText = slide.getAttribute('data-slide-title2') || '';

        titleOne.textContent = titleOneText;

        if (titleTwo) {
          titleTwo.textContent = titleTwoText;
        }

        if (titleMobile) {
          titleMobile.textContent = (titleOneText + ' ' + titleTwoText).trim();
        }

        this.setOptionalText(subtitle, slide.getAttribute('data-slide-subtitle') || '');

        var hasButtonOne = this.updateButton(
          buttonOne,
          slide.getAttribute('data-slide-button1-label') || '',
          slide.getAttribute('data-slide-button1-link') || '',
          slide.getAttribute('data-slide-button1-custom-order') || ''
        );

        var hasButtonTwo = this.updateButton(
          buttonTwo,
          slide.getAttribute('data-slide-button2-label') || '',
          slide.getAttribute('data-slide-button2-link') || '',
          slide.getAttribute('data-slide-button2-custom-order') || ''
        );

        if (buttons) {
          buttons.classList.toggle('is-hidden', !hasButtonOne && !hasButtonTwo);
          buttons.setAttribute('aria-hidden', hasButtonOne || hasButtonTwo ? 'false' : 'true');
        }
      } else {
        if (titleMobile) {
          titleMobile.textContent = '';
        }

        this.setOptionalText(subtitle, '');
        this.updateButton(buttonOne, '', '');
        this.updateButton(buttonTwo, '', '');

        if (buttons) {
          buttons.classList.add('is-hidden');
          buttons.setAttribute('aria-hidden', 'true');
        }
      }

      this.activateTitles();
      this.titlesShown = true;
    },

    activateTitles: function() {
      this.allTitles.forEach(function(title) {
        title.classList.remove(classes.finishedTitles, classes.activeTitles);
        title.offsetWidth;
        title.classList.add(classes.activeTitles);
      });
    },

    updateDots: function(index) {
      if (!this.dots.length) {
        return;
      }

      this.dots.forEach(function(dot) {
        var isActive = parseInt(dot.getAttribute('data-slide-index'), 10) === index;

        dot.classList.toggle(classes.activeDot, isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    },

    syncVideos: function() {
      this.videos.forEach(function(video) {
        if (this.inView && video.classList.contains(classes.activeImage)) {
          playVideo(video, this.section);
        } else {
          pauseVideo(video);
        }
      }.bind(this));
    },

    destroy: function() {
      this.inView = false;
      this.pause();
      this.unbindSwipe();
      this.unbindDots();
      this.unbindVideoEvents();
      window.clearTimeout(this.swipeClickTimer);

      if (this.viewportObserver) {
        this.viewportObserver.disconnect();
      }
    }
  };

  function initSection(section) {
    if (!section || section.dataset.fadingMediaHeroInit === 'true') {
      return;
    }

    section.dataset.fadingMediaHeroInit = 'true';
    instances.push(new FadingMediaHero(section));
  }

  function initAll(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches(sectionSelector)) {
      sections.push(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach(function(section) {
      sections.push(section);
    });

    sections.forEach(initSection);
  }

  function destroyAll(root) {
    instances = instances.filter(function(instance) {
      var shouldDestroy = root && (instance.section === root || root.contains(instance.section));

      if (shouldDestroy) {
        instance.destroy();
      }

      return !shouldDestroy;
    });
  }

  window.BsignFadingMediaHero = {
    initAll: initAll,
    destroyAll: destroyAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    destroyAll(event.target);
  });
})();
